<template>
  <div id="app" :class="{ 'web-browser': auth.browser }">
    <web-session-shell><keep-alive v-if="auth.browser && auth.session && $route.path !== '/login'" :key="auth.session.username" :include="cachedPages" :max="2"><router-view :key="mapPageKey" /></keep-alive><router-view v-else /></web-session-shell>
  </div>
</template>

<script>
import { webAuth } from './utils/web-auth'
import WebSessionShell from './components/WebSessionShell.vue'
import { webDispatchReturn } from './utils/web-navigation'
export default {
  components: { WebSessionShell },
  data() { return { auth: webAuth } },
  computed: {
    cachedPages() { return this.$route.path === '/dispatchCenter' || webDispatchReturn(this.$router, this.$route) ? 'WebHome,DispatchCenter' : 'WebHome' },
    mapPageKey() {
      if (this.$route.path !== '/dispatchCenter') return undefined
      const query = { ...this.$route.query }
      delete query.appFontSize
      return this.$router.resolve({ path: this.$route.path, query, hash: this.$route.hash }).route.fullPath
    }
  }
}
</script>

<style>
/* Cover every touch target, including dialogs appended to body. */
* {
  -webkit-tap-highlight-color: transparent !important;
}

#app.web-browser { min-height: 100vh; min-height: 100dvh; background: #fff; }
/* Match the native page and WebView loading background on every App route. */
#app:not(.web-browser) {
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #f5faff;
}
#app:not(.web-browser) > div > :not(.app-expired),
#app:not(.web-browser) .users-toolbar,
#app:not(.web-browser) .map-initial-loading {
  background-color: #f5faff;
}
/* Disable long-press text selection throughout the WebView. */
body {
  -webkit-user-select: none;
  user-select: none;
}

/* Keep selection and editing available in form fields and editable content. */
input,
textarea,
[contenteditable=""],
[contenteditable="true"],
[contenteditable="plaintext-only"] {
  -webkit-user-select: text;
  user-select: text;
}

/* App WebView: hide vertical scrollbars without changing scrolling or horizontal tables. */
*::-webkit-scrollbar {
  width: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
} */

body{
	margin:0;
	padding:0;
	border:0
}

</style>
